// Display branding remains untouched. These colors are for workspace controls only.
const rgb = hex => /^#[0-9a-f]{6}$/i.test(hex || '') ? [1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)) : [37,99,235];
const luminance = color => rgb(color).map(v=>{const c=v/255;return c<=.04045?c/12.92:((c+.055)/1.055)**2.4}).reduce((n,c,i)=>n+c*[.2126,.7152,.0722][i],0);
export const contrast=(a,b)=>{const x=luminance(a),y=luminance(b);return (Math.max(x,y)+.05)/(Math.min(x,y)+.05)};
export function workspaceAccent(input,mode){
 const surface=mode==='dark'?'#1c2028':'#ffffff',target=mode==='dark'?255:0,base=rgb(input);
 let accent='#'+base.map(v=>v.toString(16).padStart(2,'0')).join('');
 for(let step=1;contrast(accent,surface)<5.2&&step<=20;step++)accent='#'+base.map(v=>Math.round(v+(target-v)*step/20).toString(16).padStart(2,'0')).join('');
 return {accent,onAccent:contrast(accent,'#ffffff')>=4.5?'#ffffff':'#111827'};
}
